import React from 'react';
import { ChevronDown, MapPin } from 'lucide-react';

export const localFaqs = [
  {
    question: 'Welche Fliesenarbeiten bietet Fliesen Jarek an?',
    answer: 'Zum Leistungsspektrum gehören komplette Badsanierungen, Wand- und Bodenfliesen, Großformatfliesen, Naturstein, Mosaik, Abdichtungsarbeiten sowie Reparaturen und die Erneuerung vorhandener Flächen.'
  },
  {
    question: 'In welchem Gebiet ist Fliesen Jarek tätig?',
    answer: 'Der Schwerpunkt liegt in Cuxhaven und der näheren Umgebung. Je nach Projekt werden auch Aufträge in Otterndorf, Hemmoor, Bremerhaven und im Raum Stade übernommen.'
  },
  {
    question: 'Wie läuft eine Anfrage für eine Badsanierung ab?',
    answer: 'Nach dem ersten Gespräch folgt in der Regel ein Termin vor Ort. Dabei werden Untergrund, Maße und Wünsche geklärt. Anschließend erhalten Sie ein transparentes Angebot und eine realistische Zeitplanung.'
  },
  {
    question: 'Was kostet eine professionelle Fliesenverlegung?',
    answer: 'Die Kosten hängen unter anderem von Fläche, Untergrund, Fliesenformat, Material und Detailaufwand ab. Deshalb wird jedes Vorhaben individuell kalkuliert und vor Beginn nachvollziehbar angeboten.'
  },
  {
    question: 'Werden auch kleinere Reparaturen ausgeführt?',
    answer: 'Ja. Neben kompletten Renovierungen übernimmt Fliesen Jarek auch den Austausch beschädigter Fliesen, Fugenerneuerungen und weitere Reparaturarbeiten nach vorheriger Abstimmung.'
  }
];

const LocalSeoContent = () => (
  <section id="faq" className="bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-8">
      <div>
        <div className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-800">
          <MapPin className="h-4 w-4" />
          Cuxhaven & Umgebung
        </div>
        <h2 className="mt-5 font-display text-3xl font-semibold leading-tight text-stone-900 sm:text-4xl">
          Ihr Ansprechpartner für Fliesenarbeiten in Cuxhaven
        </h2>
        <div className="mt-6 space-y-4 text-base leading-relaxed text-stone-600">
          <p>
            Fliesen Jarek begleitet private und gewerbliche Projekte von der ersten Beratung bis zur sauberen Abnahme. Der Schwerpunkt liegt auf Badsanierung, präziser Fliesenverlegung und technisch sicheren Aufbauten im Nassbereich.
          </p>
          <p>
            Als persönlich geführter Fliesenlegerbetrieb erhalten Sie einen festen Ansprechpartner, klare Absprachen und eine Ausführung, die Gestaltung und Haltbarkeit zusammenbringt.
          </p>
        </div>
        <a href="/leistungen" className="mt-7 inline-flex font-semibold text-primary-700 transition hover:text-primary-900">
          Alle Leistungen im Überblick →
        </a>
      </div>

      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-primary-700">Häufige Fragen</p>
        <h2 className="mt-2 font-display text-2xl font-semibold text-stone-900 sm:text-3xl">
          Kurz und verständlich beantwortet
        </h2>
        <div className="mt-6 divide-y divide-stone-200 border-y border-stone-200">
          {localFaqs.map((faq, index) => (
            <details key={faq.question} className="group py-5" open={index === 0}>
              <summary className="flex cursor-pointer list-none items-start justify-between gap-5 font-semibold leading-snug text-stone-900">
                {faq.question}
                <ChevronDown className="mt-0.5 h-5 w-5 shrink-0 text-primary-700 transition group-open:rotate-180" />
              </summary>
              <p className="mt-3 pr-8 text-sm leading-relaxed text-stone-600 sm:text-base">{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default LocalSeoContent;
